import { motion } from "framer-motion";
import { ExternalLink } from "lucide-react";
import bookCover from "@/assets/divine-overflow-book.jpg";

const BookSection = () => {
  return (
    <section className="py-24 md:py-32 relative">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,_hsl(43_72%_55%_/_0.05),_transparent_60%)]" />

      <div className="container mx-auto px-6 md:px-12 relative">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <p className="text-xs uppercase tracking-[0.4em] text-gold font-body font-medium mb-4">
            From the Founder
          </p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-display font-bold text-foreground leading-tight">
            Get the <span className="text-gradient-gold">Devotional</span>
          </h2>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 md:gap-20 items-center max-w-5xl mx-auto">
          {/* Book cover */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.1 }}
            className="flex justify-center"
          >
            <div className="relative group">
              <div className="absolute -inset-4 border border-gold/15 transition-all duration-500 group-hover:border-gold/30" />
              <div className="absolute -inset-8 border border-gold/8" />
              <img
                src={bookCover}
                alt="Divine Overflow Devotional – 30 Days of Faith-Fueled Wealth and Prosperity by Angela J. Roberson"
                className="relative w-64 md:w-72 shadow-luxury"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </div>
          </motion.div>

          {/* Book details */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="space-y-6 text-center md:text-left"
          >
            <h3 className="text-2xl md:text-3xl font-display font-bold text-foreground leading-snug">
              Divine Overflow Devotional
            </h3>
            <p className="text-gold font-body text-sm uppercase tracking-[0.2em] font-medium">
              30 Days of Faith-Fueled Wealth &amp; Prosperity
            </p>
            <p className="text-muted-foreground font-body text-base md:text-lg leading-relaxed">
              Dive into a transformative 30-day journey that seamlessly weaves together the timeless teachings of Christianity and practical wealth-building insights. Each day, discover a carefully curated blend of ancient wisdom and modern strategies to navigate the intersection of faith and prosperity.
            </p>
            <p className="text-muted-foreground font-body text-sm leading-relaxed">
              By <span className="text-foreground font-medium">Angela J. Roberson</span> · Paperback · 40 pages
            </p>

            <a
              href="https://a.co/d/0es3CBZ1"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-gradient-gold text-primary-foreground font-body font-semibold text-sm uppercase tracking-[0.15em] px-8 py-4 hover:opacity-90 transition-opacity duration-300 shadow-gold"
            >
              Get Your Copy — $15
              <ExternalLink size={16} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default BookSection;
